import { DealClassifierTct } from '@dealstack/shared/lib/generated';

type DealClassifierOption = {
	value: string;
	label: string;
};

const visit = (items: DealClassifierTct[], out: DealClassifierOption[]): void => {
	for (const item of items) {
		out.push({ value: item.id, label: item.name });
		if (item.children?.length) {
			visit(item.children, out);
		}
	}
};

/**
 * Flattens the deal classifier tree (parent + children) into a flat list of
 * `{ value, label }` options suitable for a Mantine multi-select. Parent and
 * child classifiers are returned as siblings — no visual nesting.
 */
export const flattenDealClassifiersToOptions = (
	classifiers: DealClassifierTct[] = []
): DealClassifierOption[] => {
	const out: DealClassifierOption[] = [];
	visit(classifiers, out);
	return out;
};
